export default __webpack_public_path__ + "static/media/unlock.6034b240.png";